import React from 'react';
import './Partners.css?v=2';

const Partners = () => {
  const partners = [
    { id: 1, name: '삼성디스플레이', logo: '/collabo_ssdisplay.png' },
    { id: 2, name: 'SK하이닉스', logo: '/collabo_skhynix.png' },
    { id: 3, name: '현대건설', logo: '/collabo_hyundai.png' },
    { id: 4, name: 'POSCO 이앤씨', logo: '/collabo_posco.png' },
    { id: 5, name: 'DAEWOO E&C', logo: '/collabo_daewoo.png' },
    { id: 6, name: 'GS건설', logo: '/collabo_gs.png' },
    { id: 7, name: 'DL이앤씨', logo: '/collabo_dl.png' },
    { id: 8, name: 'SK에코플랜트', logo: '/collabo_skeco.png' }
  ];

  return (
    <section className="partners" id="partners">
      <div className="partners-container">
        <div className="partners-header">
          <h2 className="partners-title">주요 협력사</h2>
          <p className="partners-subtitle">신뢰할 수 있는 파트너들과 함께 성장하고 있습니다</p>
        </div>

        <div className="partners-grid">
          {partners.map((partner) => (
            <div key={partner.id} className="partner-item">
              <div className="partner-logo">
                <img src={partner.logo} alt={partner.name} className="partner-image" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
